import { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../lib/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await apiFetch('/api/auth/forgot-password', {
        method: 'POST',
        body: { email },
      });
      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logoRow}>
          <img src="https://www.masterfileai.com/hubfs/logo3.png" alt="MasterFileAI" style={{ height: 36, maxWidth: 200, objectFit: 'contain' }}
            onError={e => { e.target.style.display='none'; e.target.nextElementSibling.style.display='block'; }} />
          <span style={{ display:'none', color:'#0f172a', fontWeight:700, fontSize:20 }}>MasterFileAI</span>
        </div>

        {submitted ? (
          <>
            <div style={styles.iconWrap}>📬</div>
            <h1 style={styles.heading}>Check your inbox</h1>
            <p style={styles.sub}>
              If <strong style={{ color: '#111827' }}>{email}</strong> has an account, we've sent a
              password reset link. It expires in 30 minutes.
            </p>
            <p style={styles.footerText}>
              <Link to="/login" style={styles.link}>← Back to sign in</Link>
            </p>
          </>
        ) : (
          <>
            <h1 style={styles.heading}>Reset your password</h1>
            <p style={styles.sub}>
              Enter your work email and we'll send you a reset link.
            </p>
            {error && <div style={styles.errorBox}>{error}</div>}
            <form onSubmit={handleSubmit} style={styles.form}>
              <label style={styles.label}>Work email</label>
              <input
                style={styles.input}
                type="email"
                placeholder="you@company.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoFocus
              />
              <button type="submit" style={styles.btn} disabled={loading}>
                {loading ? 'Sending…' : 'Send reset link'}
              </button>
            </form>
            <p style={styles.footerText}>
              <Link to="/login" style={styles.link}>← Back to sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#f0f5fb', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', fontFamily: "'Inter', system-ui, sans-serif" },
  card: { background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: 16, padding: '48px 40px', width: '100%', maxWidth: 400, boxShadow: '0 4px 24px rgba(1,118,206,0.08)' },
  logoRow: { display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 32 },
  iconWrap: { fontSize: 44, marginBottom: 16, textAlign: 'center' },
  heading: { color: '#0f172a', fontSize: 22, fontWeight: 700, margin: '0 0 12px', letterSpacing: '-0.3px' },
  sub: { color: '#64748b', fontSize: 14, lineHeight: 1.6, margin: '0 0 28px' },
  errorBox: { background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.4)', borderRadius: 8, color: '#dc2626', fontSize: 13, padding: '10px 14px', marginBottom: 20 },
  form: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { color: '#64748b', fontSize: 12, fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: 10 },
  input: { background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, color: '#0f172a', fontSize: 14, padding: '11px 14px', outline: 'none', width: '100%', boxSizing: 'border-box' },
  btn: { marginTop: 20, background: '#F37428', border: 'none', borderRadius: 8, color: '#fff', cursor: 'pointer', fontSize: 15, fontWeight: 600, padding: '13px', width: '100%' },
  footerText: { color: '#94a3b8', fontSize: 13, textAlign: 'center', marginTop: 24 },
  link: { color: '#0176CE', textDecoration: 'none', fontWeight: 500 },
};
